export interface AuditItem {
  key: string;
  label: string;
  value: string;
}

const auditDateOptions: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
};

export function formatAuditDate(dateValue?: string | number | Date): string {
  if (!dateValue) return "";
  const parsed = new Date(dateValue);
  return isNaN(parsed.getTime()) ? "" : parsed.toLocaleDateString("en-US", auditDateOptions);
}
